import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ModalClose from '../images/modal-close.svg';

import { default as ReactModal } from 'react-modal';

export default class Modal extends Component {
  static APP_PAGE = '.page-home';

  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      openedAt: null,
    };
  }

  componentDidMount() {
    if (document.querySelector(Modal.APP_PAGE)) {
      ReactModal.setAppElement(Modal.APP_PAGE);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open) {
      this.setState({ open: this.props.open }, () => {
        if (this.props.open) {
          this.onAfterOpen();
        } else {
          this.onAfterClose();
        }
      });
    }
  }

  render() {
    return (
      <div className="modal__wrapper">
        {this.props.noButton || (
          <a className={this.modalButtonClasses} onClick={this.onOpen}>
            {this.props.button}
          </a>
        )}
        <ReactModal
          overlayClassName={this.modalClasses}
          className="modal__inner"
          isOpen={this.state.open}
          onRequestClose={this.onClose}
          shouldCloseOnOverlayClick={this.props.shouldCloseOnOverlayClick}
        >
          <Fragment>
            <img className="modal__close" src={ModalClose} onClick={this.onClose} />
            {this.props.children}
          </Fragment>
        </ReactModal>
      </div>
    );
  }

  get modalClasses() {
    const classes = ['modal', this.props.className];
    return classes.join(' ');
  }

  get modalButtonClasses() {
    const classes = ['modal__button', this.props.buttonClassName];
    return classes.join(' ');
  }

  onOpen = () => {
    this.setState({ open: true, openedAt: Date.now() }, this.onAfterOpen);
  };

  onAfterOpen = () => {
    const appPage = document.querySelector(Modal.APP_PAGE);
    if (appPage) {
      appPage.classList.add('app-page--modal-open');
    }
    this.props.gaCategory && this.trackGaEvent('open');
    this.props.onOpen && this.props.onOpen();
  };

  onClose = () => {
    this.setState({ open: false }, this.onAfterClose);
  };

  onAfterClose = () => {
    const appPage = document.querySelector(Modal.APP_PAGE);
    const secondsViewed = (Date.now() - this.state.openedAt) / 1000;

    if (appPage) {
      appPage.classList.remove('app-page--modal-open');
    }

    this.props.gaCategory && this.trackGaEvent('close', secondsViewed);
    this.props.onClose && this.props.onClose();
  };

  trackGaEvent = (action, value = null) => {
    // Category, action, label, value
    track_event(this.props.gaCategory, action, null, value);
  };
}

Modal.propTypes = {
  className: PropTypes.string,
  wrapperClassName: PropTypes.string,
  render: PropTypes.func,
  open: PropTypes.bool,
  noButton: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
};
